module.exports = __webpack_public_path__ + "img/selected3-min.b6c30541.png";